import { render, staticRenderFns } from "./UpdateOSDP.vue?vue&type=template&id=11651484"
import script from "./UpdateOSDP.vue?vue&type=script&lang=js"
export * from "./UpdateOSDP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports